import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { routesMap } from '@shared/lib';
import { Button } from '@/components/ui/button';
import { useGetClientProfile } from '@entities/client/model';
import PageLoader from '@ui/PageLoader';

export const PlanSuccessPage: React.FC = () => {
  const { planType } = useParams<{ planType: string }>();

  const { profile, isLoading } = useGetClientProfile();

  if (!planType) return null;

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center bg-black px-[20px] md:px-[32px]">
      {isLoading ? (
        <PageLoader />
      ) : (
        <div className="mt-8 flex max-w-[370px] flex-col items-center justify-center text-center">
          <div className="mb-[36px] flex items-end gap-[7px]">
            <h1
              className="max-w-[165px] text-left text-[48px] font-medium leading-[120%] text-[#F6F6F9]"
              style={{
                fontFeatureSettings:
                  "'case' on, 'liga' off, 'clig' off, 'calt' off",
              }}
            >
              You&apos;re on{' '}
              <span className="capitalize">
                {profile?.subscriptions[0].tariff.name}
              </span>
            </h1>
            <div className="w-full">
              <img src="/crown.png" className="w-full" alt="Crown" />
            </div>
          </div>

          <p
            className="mb-[24px] text-left text-[16px] font-medium leading-[150%] text-[#F6F6F9]"
            style={{
              fontFeatureSettings:
                "'cv02' on, 'cv03' on, 'cv04' on, 'cv11' on, 'liga' off, 'clig' off, 'calt' off",
              fontVariantNumeric: 'lining-nums tabular-nums',
            }}
          >
            Congratulations! You have successfully transitioned to the{' '}
            <span className="capitalize">
              {profile?.subscriptions[0].tariff.name}
            </span>{' '}
            Plan. Keep an eye on your limits and get the most out of it
          </p>

          <div className="flex w-full max-w-[400px] flex-col gap-4">
            <Button
              className="w-full rounded-xl border border-[#272B30] bg-transparent py-4 text-[16px] font-medium text-white hover:bg-[rgba(255,255,255,0.1)]"
              size="lg"
              asChild
            >
              <Link to={routesMap.limits.full}>See limits</Link>
            </Button>

            <Button
              className="w-full rounded-xl bg-white py-4 text-[16px] font-medium text-black hover:bg-gray-100"
              size="lg"
            >
              <Link to={routesMap.home}>Going to dashboard</Link>
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PlanSuccessPage;
